export const apiEndPoints = {
  // Authentication endpoints
  ADMIN_LOGIN: "admin/auth/login",
  ADMIN_VERIFY_OTP: "admin/verify-otp",
  ADMIN_PROFILE: "admin/auth/profile",
  ADMINS: "admin/auth/admins",
  
  GET_CLIENT_DATA: "admin/clients",
  GET_CLIENT_DETAILS: "admin/user",
  GET_FRELANCER_DATA:"admin/freelancers",
  GET_REFERRAL_PARTNER_DATA: "admin/referral-partners",
  GET_FREELANCER_COMPLETE_DATA: "admin/freelancer",
  UPDATE_FREELANCER_PRIMARY_INTRODUCTION: "admin/freelancer",
  UPDATE_FREELANCER_PROFESSIONAL_EXPERIENCE: "admin/freelancer",
  UPDATE_FREELANCER_PROJECTS: "admin/freelancer",
  SEND_EMAIL_TO_FREELANCER: "admin/freelancer",
  UPDATE_FREELANCER_EDUCATION: "admin/freelancer",
  GET_CONTACT_US:"admin/contact-us",
  STATUS_UPDATE:"admin/user",
  GET_ENROLL_AS: "designation",
  GET_COUNTRIES: "country",
  GET_INDUSTRY:"industry",
  UPDATE_CLIENT_STATUS_IN_CONTACT_US_BY_ADMIN:"admin/update-client-status",
  CREATE_USER_BY_ADMIN:"admin/create-user",
  DELETE_CONTACT_US_BY_ADMIN:"admin/contact-us",
  GET_SITE_ANALYTICS:"admin/page-analytics",
  GET_IP_ANALYTICS:"admin/ip-analytics",
  GET_CLIENT_PROJECTS: "admin/projects",
  GET_CATEGORIES: "category",
  GET_SUBCATEGORIES: "user/sub-category",
  GET_TECHNOLOGIES: "technology",
  GET_INDUSTRIES: "industry",
  UPDATE_PROJECT: "admin/project",
  UPDATE_PROJECT_STATUS: "admin/project",
  CREATE_CLIENT_PROJECT: "admin/client-project",
  GET_PROJECT_PREFILL: "admin/project",
  
  // Project Bids endpoints
  GET_ALL_PROJECT_BIDS: "admin/project-bids",
  GET_PROJECT_BID_DETAILS: "admin/project-bids",
  
  // Chat endpoints
  GET_ALL_USERS: "admin/user",
  CREATE_CHAT_ROOM: "admin/chat/rooms",
  GET_ADMIN_CHAT_ROOMS: "admin/chat/rooms",
  GET_USER_CHAT_ROOMS: "admin/chat-room/not-created-by-admin",
  UPDATE_CHAT_ROOM_STATUS: "admin/chat-room",
  GET_CHAT_ROOM_MESSAGES: "admin/chat/rooms",
  SEND_MESSAGE: "chat/rooms",
  DELETE_MESSAGE: "chat/messages",
  GET_CHAT_ROOM_DETAILS: "chat/rooms",
  
  // Website Data endpoints
  WEBSITE_DATA_UPLOAD_EXCEL: "admin/website-data/upload-excel",
  WEBSITE_DATA_DOWNLOAD_EXCEL: "admin/website-data/download-excel",
  GET_WEBSITE_DATA: "admin/website-data",
  GET_WEBSITE_DATA_BY_ID: "admin/website-data",
  DELETE_WEBSITE_DATA: "admin/website-data",
  DELETE_ALL_WEBSITE_DATA: "admin/website-data",
  CREATE_WEBSITE_DATA: "admin/website-data",
  UPDATE_WEBSITE_DATA: "admin/website-data",
  GET_WEBSITE_CATEGORIES: "admin/website-data/categories",
  GET_WEBSITE_DATA_BY_CATEGORY_ADMIN: "admin/website-data/category",
  
  // Freelancer Country Preferences endpoints
  GET_FREELANCER_COUNTRY_PREFERENCES: "admin/freelancer",
  ADD_FREELANCER_COUNTRY_PREFERENCE: "admin/freelancer", 
  UPDATE_FREELANCER_COUNTRY_PREFERENCE: "admin/freelancer",
  DELETE_FREELANCER_COUNTRY_PREFERENCE: "admin/freelancer",
  
  // Freelancer Max Values endpoints
  UPDATE_MAX_PROPOSAL_VALUE: "admin/freelancer",
  UPDATE_MAX_DELIVERY_IN_PROGRESS: "admin/freelancer",

  // Blog endpoints
  CREATE_BLOG: "admin/blog",
  GET_ALL_BLOGS: "admin/blogs",
  GET_BLOG_BY_ID: "admin/blog",
  UPDATE_BLOG: "admin/blog",
  DELETE_BLOG: "admin/blog",

  // AI endpoints
  GET_EMAIL_DOMAIN_ANALYSIS: "admin/email-domain-analysis",
  GET_UNIQUE_SPECIAL_CATEGORY: "admin/unique-special-category",
  GET_ALL_CATEGORIES: "admin/categories",
  GET_SUB_CATEGORIES_BY_CATEGORY: "admin/sub-categories",
  GET_BATCH_NAME: "admin/batch-name",
  /** Proxied via halogig-internal-backend → AI service (admin Bearer required) */
  DRAFT_CAMPAIGN_NAMES: "draft/campaign-names",
  FOLLOWUP_START: "followup/start",
  GET_HTML_TEMPLATE: "admin/html-template",
  GET_WEBSITE_DATA_SLUG: "admin/website-data-slug",
  GET_WEBSITE_DATA_SLUGS: "admin/website-data-slugs",
  UPDATE_WEBSITE_DATA_ORDER: "admin/website-data/update-order",
  CAMPAIGN_SEND: "campaign/send",
  GET_EMAIL_CAMPAIGNS: "admin/email-campaigns",

  // Category / SubCategory / Technology management (CRUD)
  CATEGORY_MANAGEMENT_CATEGORIES: "admin/category-management/categories",
  SUBCATEGORY_MANAGEMENT_SUB_CATEGORIES: "admin/category-management/sub-categories",
  TECHNOLOGY_MANAGEMENT_TECHNOLOGIES: "admin/category-management/technologies",
  
  // Pending view counts endpoint
  GET_PENDING_VIEW_COUNTS: "admin/pending-view-counts",
  
  // Freelancer Payments endpoint
  GET_ALL_FREELANCER_PAYMENTS: "admin/freelancer-payments",
  
  // Disputes endpoints
  GET_ALL_ADMIN_DISPUTES: "admin/disputes/all",
  UPDATE_ADMIN_DISPUTE_STATUS: "admin/disputes",
  GET_DISPUTES_BY_TYPE: "admin/disputes",
  
  // Sales Referral Leads (Admin)
  GET_ADMIN_SALES_REFERRAL_LEADS: "admin/sales-referral-leads",
  GET_ADMIN_SALES_REFERRAL_LEAD_DETAIL: "admin/sales-referral-leads",
  UPDATE_ADMIN_SALES_REFERRAL_LEAD_STATUS: "admin/sales-referral-leads",
  
  // Admin Notifications - REMOVED
  
  // Testimonial endpoints
  CREATE_TESTIMONIAL: "admin/testimonial",
  GET_ALL_TESTIMONIALS: "admin/testimonials",
  UPDATE_TESTIMONIAL: "admin/testimonial",
  DELETE_TESTIMONIAL: "admin/testimonial",
  UPDATE_TESTIMONIAL_STATUS: "admin/testimonial",
  
  // Web Rotation Data endpoints
  GET_WEB_ROT_DATA: "admin/web-rot-data",
  GET_WEB_ROT_UNIQUE_INDUSTRIES: "admin/web-rot-data/unique-industries",
  GET_WEB_ROT_UNIQUE_SLUG_LINKS: "admin/web-rot-data/unique-slug-links",

  // LinkedIn token management
  LINKEDIN_AUTHORIZE: "admin/linkedin/authorize",
  LINKEDIN_GENERATE_TOKENS: "admin/linkedin/generate-tokens",
  LINKEDIN_TOKEN_DETAILS: "admin/linkedin/token-details",
  LINKEDIN_TOGGLE_STATUS: "admin/linkedin/toggle-status",
  LINKEDIN_CLEAR_TOKENS: "admin/linkedin/clear-tokens",

  // Google token management
  GOOGLE_AUTHORIZE: "admin/google-meet/authorize",
  GOOGLE_GENERATE_TOKENS: "admin/google-meet/generate-tokens",
  GOOGLE_TOKEN_DETAILS: "admin/google-meet/token-details",
  GOOGLE_CLEAR_TOKENS: "admin/google-meet/clear-tokens",

  // Twitter token management
  TWITTER_SAVE_TOKENS: "admin/twitter/save-tokens",
  TWITTER_TOKEN_DETAILS: "admin/twitter/token-details",
  TWITTER_CLEAR_TOKENS: "admin/twitter/clear-tokens",
  TWITTER_TOGGLE_STATUS: "admin/twitter/toggle-status",
  TWITTER_TEST_CONNECTION: "admin/twitter/test-connection",

  // Currency Exchange Rate
  GET_CURRENCY_RATES: "admin/currency-rates",
  REFRESH_CURRENCY_RATE: "admin/currency-rates/refresh",
};
